import { makeStyles } from '@material-ui/core/styles';
import DehazeIcon from '@material-ui/icons/Dehaze';
import Button from '@material-ui/core/Button';

import Drawer from "@material-ui/core/Drawer";
import NestedList from './NestedList';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Divider from "@material-ui/core/Divider";
//import FormControl from '@material-ui/core/FormControl';
//import Select from '@material-ui/core/Select';
//import InputLabel from '@material-ui/core/InputLabel';
//import MenuItem from '@material-ui/core/MenuItem';
//import TextField from '@material-ui/core/TextField';

import React, { useState, useRef } from 'react';
import { ThemeProvider } from 'styled-components';
import { useOnClickOutside } from './hooks';
import { GlobalStyles } from './global';
import { theme } from './theme';
import { Burger, Menu } from './components';
import FocusLock from 'react-focus-lock';
import './App.css'
import MyAppliances from './components/MyAppliances/MyAppliances';
import Navigate from './components/Navigate/Navigate';
import CartProvider from './store/CartProvider';

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    //color: '#ed7315',
    //borderColor: '#ed7315',
    //'&:hover':{ borderColor: '#ed7315', backgroundColor: "#ffebccdd"}
  },

  drawerPaper: {
    width: '20vw',
    minWidth: '140px',
    maxWidth: '35vw',
    overflowY: "auto",
    overflowX: 'hidden',
    //background: "#c7addd"
    
  },
  root: {
    width: '20vw',
     /*'& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    }, */
    //marginRight: '5vh',
    //maxWidth: 360,
    //backgroundColor: theme.palette.background.paper,
  },

  nested: {
    paddingLeft: theme.spacing(4),
  },

  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },

  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));


//function App() {
//
//  const classes = useStyles();
//
//  //States for opening Drawer
//  const [state, setState] = React.useState({
//    top: false,
//    left: false,
//    bottom: false,
//    right: false,
//  });
//
//  //Open Drawer after Scene is loaded (IF NEEDED)
//  /*
//  React.useEffect( ()=> {
//
//    waitForGlobal("scene", openMenu); 
//    //Function waiting for Global Variables (Camera) 
//    function waitForGlobal (key, callback) {
// 
//     if (window[key]) {
//         
//         if(window[key]._prepared == true)
//             { callback(); }
//         else { 
//             setTimeout(function() {
//             waitForGlobal(key, callback);
//           }, 100);}
//     } else { 
//         setTimeout(function() {
//         waitForGlobal(key, callback);
//       }, 100);} 
//    }
// },[]); */
//
//
//
//
//  //Open Drawer
//  const toggleDrawer = (anchor, open) => (event) => {
//    if(open==true){ 
//        document.getElementById('root').style.width = '13vw'; 
//        //document.getElementById('hotspot1').style.marginLeft = '13vw';
//      } else{
//        document.getElementById('root').style.width = '0vw';
//      }  
//    
//    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
//      return;
//    }
//  
//  //Open Drawer states
//  setState({ ...state, [anchor]: open });
//  };
//
//  //Functions to Handle Navigation Values
//  /* function handleRotation (e) {window.scene._nav._navRotationSpeed = e.target.value}
//  function handleDolly (e) {window.scene._nav._navDollySpeed = e.target.value}
//  function handlePan (e) {window.scene._nav._navPanSpeed = e.target.value}
//  function handleDecay (e) {window.scene._nav._navDecay = e.target.value}
//  function handleDecayHalfLife (e) {window.scene._nav._navMode2DecayHalflife = e.target.value}
//  function handleTouch (e) {window.touchSensitivity = e.target.value}
//  function handleTouchZoom (e) {window.touchZoom = e.target.value} 
//  function handleTouchPan (e) {window.touchPan = e.target.value} */
//
//  return (
//    <div className={classes.root}>
//    
//      <Button
//        variant="outlined"
//        color="primary"
//        size="large"
//        className={classes.button}
//        startIcon={<DehazeIcon />}
//        disableElevation
//        onClick={toggleDrawer("left", true)}
//      >
//        States
//      </Button>
//      
//
//      <div
//            tabIndex={0}
//            role="button"
//            //onClick={toggleDrawer("left", false)}
//            //onKeyDown={toggleDrawer("left", false)}
//          >
//            
//            <Drawer anchor={"left"} open={state["left"]} variant="persistent"  onClose={toggleDrawer("left", false)} classes={{ paper: classes.drawerPaper }}>
//              <Button
//                variant="outlined"
//                color="secondary"
//                className={classes.button}
//                startIcon={<HighlightOffIcon />}
//                onClick={toggleDrawer("left", false)}
//              >
//                Close
//              </Button> 
//            
// {/*              <div className={classes.root}>
//              <TextField id="outlined-search" label="Rotation Speed 0.2-0" type="number" variant="outlined" defaultValue={0.02} onChange={handleRotation} />
//              <TextField id="outlined-search" label="Zoom Speed 0.01-0" type="number" variant="outlined" defaultValue={0.002} onChange={handleDolly} /><br />
//              <TextField id="outlined-search" label="Pan Speed 0.1-0" type="number" variant="outlined" defaultValue={0.04} onChange={handlePan} />
//              <TextField id="outlined-search" label="Decay 1-0" type="number" variant="outlined" defaultValue={0.85} onChange={handleDecay} /><br />
//              <TextField id="outlined-search" label="Decay Life 0-Infinity" type="number" variant="outlined" defaultValue={150} onChange={handleDecayHalfLife} />
//              <TextField id="outlined-search" label="Touch Sensitivity" type="number" variant="outlined" defaultValue={5.0} onChange={handleTouch} /><br />
//              <TextField id="outlined-search" label="Touch Zoom" type="number" variant="outlined" defaultValue={3000.0} onChange={handleTouchZoom} />
//              <TextField id="outlined-search" label="Touch Pan" type="number" variant="outlined" defaultValue={400.0} onChange={handleTouchPan} />
//
//              </div>  */}
//
//              <Divider />
//              <NestedList />
//
//            </Drawer>
//      </div>
//
//
//    </div>
//  );
//}


function App() {
  const [open, setOpen] = useState(false);
  const node = useRef();
  const menuId = "main-menu";
  const burgerId = "burger-menu";

  React.useEffect(() => {
    const timer = setInterval(() => {
      if(window.showMenu) {
      setOpen(true);
      clearInterval(timer);
      }
      
    }, 1);
    
  },[]);




  // const timer = setInterval(() => {
  //   if(window.showGeo) {
  //     setOpen(true);
  //     clearInterval(timer);
  //   }
  // }, 1000);
  // useOnClickOutside(node, () => setOpen(false));

  return (
    <ThemeProvider theme={theme}>
      <CartProvider>
      <div style={{fontFamily: 'SourceSansPro'}}>
        <GlobalStyles />
        <div ref={node}>
          <FocusLock disabled={!open}>
            <Burger open={open} setOpen={setOpen} aria-controls={menuId} id={burgerId} style={{display: 'none'}} />
            <Menu open={open} setOpen={setOpen} id={menuId} style={{zIndex: '1', display: 'none'}} />
            
          </FocusLock>
          
        </div>
{/* //        <div>
//          <h1>Hello. This is HMX Media</h1>
//          <img src="https://image.flaticon.com/icons/svg/2016/2016012.svg" alt="burger icon" />
//          <small>Design made by <a href="https://www.example.com">Kartik</a> from <a href="https://www.example.com">www.example.com</a></small>
//        </div> */}
        
      </div>
      <MyAppliances />
      <Navigate />
      </CartProvider>
    </ThemeProvider>
  );
}
export default App;
